let config = {
    ignoredKeys: [8, 13, 16, 17, 18, 27, 37, 38, 39, 40] // Arrow keys + enter + esc + shift + alt + ctrl + backspace
};

export default class InputMask {
    constructor(element) {
        this.$element = $(element);
        this.regex = new RegExp(this.$element.data('mask'));
    }

    keypress(event) {
        let char = String.fromCharCode(event.which);
        let matchRegex = this.regex.test(char);
        let isSpecialCharacter = $.inArray(event.keyCode, config.ignoredKeys) !== -1;
        return matchRegex || isSpecialCharacter;
    }

    paste(event) {
        let value = event.originalEvent.clipboardData.getData('Text');
        return this.regex.test(value);
    }

    init() {
        this.$element
            .off('keypress.inputMask', '', $.proxy(this, 'keypress'))
            .on('keypress.inputMask', $.proxy(this, 'keypress'))
            .off('paste.inputMask', '', $.proxy(this, 'paste'))
            .on('paste.inputMask', $.proxy(this, 'paste'));
    }
}
